// Angular
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
// NGRX
import { select, Store } from '@ngrx/store';
// RxJS
import { Observable, Subscription } from 'rxjs';

import { SubheaderService } from '../../../../../core/_base/layout';
import { currentUser, User } from '../../../../../core/auth';
// AppState
import { AppState } from '../../../../../core/reducers';

@Component({
  selector: 'kt-user-files',
  templateUrl: './user-files.component.html',
  styleUrls: ['./user-files.component.scss'],
})
export class UserFilesComponent implements OnInit, OnDestroy {
  curUser: Observable<User>;
  private subscriptions: Subscription[] = [];

  constructor(
    private store: Store<AppState>,
    private router: Router,
    private subheaderService: SubheaderService
  ) {}

  ngOnInit() {
    this.curUser = this.store.pipe(select(currentUser));
    this.subheaderService.setTitle('Διαχείριση Αρχείων');
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sb => sb.unsubscribe());
  }
}
